import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Eyebrow, MaskHeading, Reveal, Gold } from "./Motion";
import { FLAVOURS } from "./data";

export const Flavours = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="flavours" ref={ref} data-testid="flavours-section" className="bg-ns-ivory py-24 md:py-36">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-t-full rounded-b-[32px] bg-ns-night" data-testid="flavours-image-frame">
            <motion.img style={{ y, scale: 1.14 }} src="/images/nine-flavours.jpg" alt="NutriSwaad 85g makhana jars in nine flavours" loading="lazy" className="aspect-[4/5] w-full object-cover" />
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Eyebrow testId="flavours-eyebrow">Discover the World of Makhana</Eyebrow>
          <MaskHeading
            testId="flavours-heading"
            className="mt-6 font-serif text-[2.6rem] font-semibold leading-[1.02] text-ns-emerald sm:text-6xl lg:text-7xl"
            lines={["9 delicious flavours,", <Gold key="g">one crunchy experience.</Gold>]}
          />
          <Reveal>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ns-muted">
              Packed in high-barrier, air-tight, induction-sealed jars so every product keeps maximum freshness and an extended shelf life.
            </p>
          </Reveal>
          <ol className="mt-12 grid gap-x-10 sm:grid-cols-2">
            {FLAVOURS.map((f, i) => (
              <Reveal key={f.name} delay={(i % 2) * 0.08}>
                <li data-testid={`flavour-item-${f.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group flex gap-5 border-t border-ns-emerald/12 py-5">
                  <span className="pt-1 font-sans text-xs font-bold tracking-[0.2em] text-ns-bronze">0{i + 1}</span>
                  <span>
                    <span className="block font-serif text-2xl font-semibold text-ns-emerald transition-colors duration-300 group-hover:text-ns-goldtext">{f.name}</span>
                    <span className="mt-1 block text-sm text-ns-muted">{f.text}</span>
                  </span>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
